// ErrorScreen (IMPLEMENTATION §2.1, §3 M11 "support gate and ErrorScreen"): an unsupported browser (the
// support gate: iOS 16+ / Chrome 107+ with WebGL), a data failure, a boot exception or a halted frame.
// role="alert" (the e2e boot fixture fails fast on it). An optional Reload button (not for an unsupported
// browser: reloading cannot help there).
export interface ErrorScreenProps {
  title: string;
  detail: string;
  reload: string | null;
  onReload(): void;
}

export function ErrorScreen({ title, detail, reload, onReload }: ErrorScreenProps) {
  return (
    <div class="ov-block" role="alert" data-overlay="error">
      <div class="ov-box">
        <p class="ov-title">{title}</p>
        <p class="ov-detail">{detail}</p>
        {reload !== null && (
          <button type="button" class="ov-btn" data-hit="error-reload" onClick={onReload}>
            {reload}
          </button>
        )}
      </div>
    </div>
  );
}
